import { computed } from 'vue';
import { useSubNetworksStore } from '@/stores/subNetworksStore';

const useCNetOptions = () => {
	const subNetworksStore = useSubNetworksStore();
	const cnetSelectOptions = computed(() => subNetworksStore.cnetSelectOptions);
	const cnetSelectedId = computed({
		get: () => subNetworksStore.cnetSelectedId,
		set: value => subNetworksStore.updateCnetSelectedId(value),
	});
	return {
		cnetSelectOptions,
		cnetSelectedId,
	};
};

export { useCNetOptions };
